// Fallback for when the HTTP fetch of the matching file under
// src/assets/data/print-labels-data/sheet/ fails. GENERATED FROM THAT FILE - keep
// the two identical: a drifted copy means a fetch failure quietly prints a
// different label, which is the worst moment to find the difference.
export const DEFAULT_SHEET_STYLES: string = `
/* =============================================================================
   Full-sheet copier label styles — one sheet per physical container, NO QR CODE.

   LITERAL VALUES ONLY — NO var(), NO DESIGN TOKENS.

   This sheet is inlined verbatim into the print iframe, which loads nothing else:
   src/theme/variables.css is not there, so any custom property from the app's
   token layer resolves to nothing and the sheet prints unstyled. A deliberate
   exception to the token convention governing the rest of this repo — do not
   centralize these values.
   ============================================================================= */

/* ---- CALIBRATION KNOBS ------------------------------------------------------
   PrintService.resizeFont shrinks any .label-line that overflows the page width,
   so these are starting sizes, not hard limits. The container caption is the
   largest line on the sheet because it is the one fact that distinguishes this
   page from the other pages of the same delivery.
   -------------------------------------------------------------------------- */
.label-line     { font-size: 110px; }
.line-container { font-size: 150px; }             /* BOX n of N */
/* ---- end calibration knobs ---------------------------------------------- */

/* Basic styles for label */
.label {
  display: flex; /* Use flexbox for layout */
  flex-direction: column; /* Stack children vertically */
  justify-content: space-between; /* Distribute space evenly */
  align-items: center; /* Center items horizontally */
  width: 100%; /* Full page width */
  height: calc(100vh - 120px); /* Full page height minus 70px top and 50px bottom */
  margin: 0; /* Remove margins for full-page use */
  overflow: hidden; /* Prevent content from overflowing the label */
  padding-top: 70px; /* Add space at the top */
  padding-bottom: 50px; /* Add space at the bottom */
}

/* Each line should scale independently */
.label-line {
  display: inline-block;
  text-align: center; /* Center text */
  white-space: nowrap; /* Prevent wrapping of text */
  padding: 5px; /* Reduced padding */
  font-weight: 800; /* Make text extra bold */
  line-height: 0.9;
}

/* A legacy log has no caption line — collapse it rather than leaving a gap the
   space-between layout would spread the other lines around. */
.label-line:empty {
  display: none;
  padding: 0;
}

@media print {
  /* Remove any unwanted header/footer in the print view */
  header, footer, .address-bar {
    display: none;
  }

  /* Set margins for the page */
  @page {
    margin: 0;
    size: landscape;
  }

  /* Remove padding/margin in the body */
  body {
    margin: 0;
    padding: 0;
  }
}
`;
